var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03196 19.0093L3.01186 19.0293C2.74049 18.4393 2.56962 17.7693 2.49927 17.0293C2.56962 17.7593 2.76059 18.4193 3.03196 19.0093Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48461 10.3791C10.8057 10.3791 11.8767 9.31358 11.8767 7.99914C11.8767 6.6847 10.8057 5.61914 9.48461 5.61914C8.1635 5.61914 7.09253 6.6847 7.09253 7.99914C7.09253 9.31358 8.1635 10.3791 9.48461 10.3791Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7113 2H8.28871C4.63023 2 2.44922 4.17 2.44922 7.81V16.19C2.44922 17.28 2.64018 18.23 3.01206 19.03C3.87643 20.93 5.72577 22 8.28871 22H16.7113C20.3697 22 22.5507 19.83 22.5507 16.19V13.9V7.81C22.5507 4.17 20.3697 2 16.7113 2ZM20.9125 12.5C20.1285 11.83 18.8621 11.83 18.0782 12.5L13.897 16.07C13.1131 16.74 11.8467 16.74 11.0627 16.07L10.721 15.79C10.0074 15.17 8.87166 15.11 8.06759 15.65L4.30861 18.16C4.08749 17.6 3.95683 16.95 3.95683 16.19V7.81C3.95683 4.99 5.4544 3.5 8.28871 3.5H16.7113C19.5456 3.5 21.0431 4.99 21.0431 7.81V12.61L20.9125 12.5Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/icon_gallery.8b49e4a53050017782ea5fb82ca0e9e6.svg";
export { ForwardRef as ReactComponent };